module.exports = __webpack_public_path__ + "assets/administratorSettings.svg";


//////////////////
// WEBPACK FOOTER
// ./libs/images/administratorSettings.svg
// module id = 348
// module chunks = 0